import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ButtonProps } from "antd/lib";
import React from "react";

const CbTableEditIconButton = ({
  style: externalStyles = {},
  className = "",
  ...props
}: ButtonProps) => {
  return (
    <Button
      {...props}
      type="text"
      title="Edit"
      size="small"
      className={`ca-edit-btn ${className}`}
      style={{
        ...externalStyles,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      icon={<EditOutlined />}
    />
  );
};

export default CbTableEditIconButton;
// <EditOutlined
//   // className="ca-edit-btn"
//   style={{ color: "#444653" }}
// />
